import { BroadcastDeliveryItemWithId } from 'models/broadcast.model';
import { BroadcastDeliveryStatuses } from 'interfaces';
import { FilterSettings } from '../../../common/Filters/FilterDropdown.model';

const filterSettings: Partial<
  Record<keyof BroadcastDeliveryItemWithId, FilterSettings>
> = {
  status: {
    key: 'status',
    label: 'Statuses',
    placeholder: 'Statuses',
    entityName: 'statuses',
    options: [
      BroadcastDeliveryStatuses.DELIVERED,
      BroadcastDeliveryStatuses.FAILED,
      BroadcastDeliveryStatuses.PENDING,
    ],
    selectionMode: 'multi',
  },
  errorCode: {
    key: 'errorCode',
    label: 'Error codes',
    placeholder: 'Error codes',
    entityName: 'errorCode',
    options: ['500'],
    selectionMode: 'multi',
  },
};

export default filterSettings;
